module.exports = __webpack_public_path__ + "img/ed60f85b7c9b18beb3d54558d7bcdf25.74b7560e.png";